import React, { useEffect, useState } from 'react';
import {
  CashierTransactionItem,
  CashierTransactionType,
} from '~/types/CashierTransaction';
import { useLoadingSetter } from '~/providers/LoadingProvider';
import { useNavigate } from 'react-router-dom';
import { getCashierTransaction } from '../../api';
import message from '~/utils/message';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import { Table, TableColumnsType } from 'antd';
import { formatDateTime } from '~/utils/date';
import { formatCurrency } from '~/utils/currency';

const columns: TableColumnsType<CashierTransactionItem> = [
  {
    title: 'Waktu',
    dataIndex: 'dateCreated',
    render: (value: number) => {
      return formatDateTime(value);
    },
    width: '180px',
  },
  {
    title: 'Deskripsi',
    dataIndex: 'description',
  },
  {
    title: 'Masuk',
    render: (_, item) => {
      return item.type === CashierTransactionType.In
        ? formatCurrency(item.amount)
        : null;
    },
    align: 'right',
  },
  {
    title: 'Keluar',
    render: (_, item) => {
      return item.type === CashierTransactionType.Out
        ? formatCurrency(item.amount)
        : null;
    },
    align: 'right',
  },
];

const ListCashierTransaction = () => {
  const [transactions, setTransactions] = useState<CashierTransactionItem[]>(
    []
  );
  const setLoading = useLoadingSetter();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getCashierTransaction().then((result) => {
      setLoading(false);
      const { data, error } = result;
      if (!error) {
        setTransactions(data ?? []);
      } else {
        message.error(error);
      }
    });
  }, []);

  return (
    <Container>
      <Header
        title="Histori Transaksi Kasir"
        onBack={() => {
          navigate('/');
        }}
      />
      <Container.Scrollable>
        <Table
          dataSource={transactions}
          columns={columns}
          pagination={false}
          summary={(pageData) => {
            let totalIn = 0;
            let totalOut = 0;
            pageData.forEach(({ amount, type }) => {
              if (type === CashierTransactionType.In) {
                totalIn += amount;
              } else {
                totalOut += amount;
              }
            });
            return (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  <Table.Summary.Cell
                    index={0}
                    colSpan={2}
                    className="font-bold"
                  >
                    Total
                  </Table.Summary.Cell>
                  <Table.Summary.Cell
                    index={1}
                    align="right"
                    className="font-bold"
                  >
                    {formatCurrency(totalIn)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell
                    index={2}
                    align="right"
                    className="font-bold"
                  >
                    {formatCurrency(totalOut)}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      </Container.Scrollable>
    </Container>
  );
};

export default ListCashierTransaction;
